import { render, staticRenderFns } from "./food.vue?vue&type=template&id=692dfa34&scoped=true&"
import script from "./food.vue?vue&type=script&lang=js&"
export * from "./food.vue?vue&type=script&lang=js&"
import style0 from "./food.vue?vue&type=style&index=0&id=692dfa34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692dfa34",
  null
  
)

export default component.exports